import * as angular from 'angular';
import { DatalayerGeneralConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/constants/ib-datalayer-general-constants';
import { GiftCardsUtilService } from './ib-gift-cards-utils.service';
import { digitalDataModel } from '../models/digitalData.model';

export class GiftCardsDatalayerService {
    constructor (
        private GiftCardsAppConstants: GiftCardsAppConstant,
        private DatalayerConstants: DatalayerConstantsType,
        private DatalayerGeneralConstants: DatalayerGeneralConstantsType,
        private DatalayerUtilsService: DatalayerUtilsService,
        private GiftCardsUtilService: GiftCardsUtilService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $rootScope: CommonsRootScope,
        private $timeout: ng.ITimeoutService
    ) {}

    initialDatalayer = (): void => {
        const quadrigam = this.GiftCardsAppConstants.QUADRIGAMS.REGALO;
        this.DatalayerUtilsService.initializeDatalayer(this.GiftCardsAppConstants.lang, this.GiftCardsAppConstants.market, this.GiftCardsUtilService.getDeviceType());
        this.updateDatalayerWithQuadrigam(quadrigam);
        this.updateDigitalDataWithQuadrigam(quadrigam);
        this.$timeout(() => {
            this.$rootScope.$broadcast('sendUpdateToMonetate');
            this.$rootScope.$broadcast('updateDatalayer');            
            this.$rootScope.$broadcast('updateDigitalData');
        });
    };

    addInitialProcessAndStep = (): void => {
        /* INIT DELETE GA4 MIGRATION*/
        const extendedDatalayerInfo = {};
        extendedDatalayerInfo[this.DatalayerConstants.DATALAYER_INFO.PROCESS] = this.GiftCardsAppConstants.PROCESS;
        extendedDatalayerInfo[this.DatalayerConstants.DATALAYER_INFO.STEP] = this.GiftCardsAppConstants.QUADRIGAM_STEPS.INICIO;
        this.DatalayerUtilsService.addDataLayerInfo(extendedDatalayerInfo);
        /* FIN DELETE GA4 MIGRATION*/

        const extendedDigitalDataInfo = {};
        extendedDigitalDataInfo[this.DatalayerGeneralConstants.PROCESS] = this.GiftCardsAppConstants.PROCESS;
        extendedDigitalDataInfo[this.DatalayerGeneralConstants.STEP] = this.GiftCardsAppConstants.QUADRIGAM_STEPS.INICIO;
        this.DatalayerUtilsService.addDigitalDataInfo(extendedDigitalDataInfo);

        this.$timeout(() => {
            this.$rootScope.$broadcast('sendUpdateToMonetate');
            this.$rootScope.$broadcast('updateDatalayer');            
            this.$rootScope.$broadcast('updateDigitalData');
        });
    };

    updateStepWithQuadrigam = () => {
        const quadrigam = this.getQuadrigam();
        const step = this.getStepByQuadrigam(quadrigam);
        const extendedDatalayerInfo = {};
        extendedDatalayerInfo[this.DatalayerConstants.DATALAYER_INFO.STEP] = step;
        this.updateDatalayerWithQuadrigam(quadrigam, extendedDatalayerInfo);

        const extendedDigitalDataInfo = {};
        extendedDigitalDataInfo[this.DatalayerGeneralConstants.STEP] = step;
        this.updateDigitalDataWithQuadrigam(quadrigam, extendedDigitalDataInfo);
        this.$timeout(() => {
            this.$rootScope.$broadcast('sendUpdateToMonetate');
            this.$rootScope.$broadcast('updateDatalayer');            
            this.$rootScope.$broadcast('updateDigitalData');
        });

    };

    updateDatalayerWithQuadrigam = (quadrigam: string, extendedObject: any = null): void => {
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, extendedObject, this.GiftCardsUtilService.isUserLogged());
    };

    updateDigitalDataWithQuadrigam = (quadrigam: string, extendedObject: any = null): void => {
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, extendedObject, this.GiftCardsUtilService.isUserLogged());
        this.$timeout(() => {
            this.$rootScope.$broadcast('sendUpdateToMonetate');
            this.$rootScope.$broadcast('updateDatalayer');            
            this.$rootScope.$broadcast('updateDigitalData');
        });
    };

    private getQuadrigam = (): string => {
        const digitalData: digitalDataModel = this.localStorageService.get('confirmationDigitalInfo');
        return digitalData.Quadrigam;
    };

    private getStepByQuadrigam = (quadrigam: string): string => {
        let step: string = '';
        if (quadrigam === this.GiftCardsAppConstants.QUADRIGAMS.REGOTR || quadrigam === this.GiftCardsAppConstants.QUADRIGAMS.REGMIO) {
            step = this.GiftCardsAppConstants.QUADRIGAM_STEPS.SELECCION;
        } else if(quadrigam === this.GiftCardsAppConstants.QUADRIGAMS.GIFTCARDS_PAYMENT) {
            step = this.GiftCardsAppConstants.QUADRIGAM_STEPS.PAGO;
        } else if(quadrigam === this.GiftCardsAppConstants.QUADRIGAMS.REBKCF) {
            step = this.GiftCardsAppConstants.QUADRIGAM_STEPS.CONFIRMACION;
        } else if(quadrigam === this.GiftCardsAppConstants.QUADRIGAMS.REGALO) {
            step = this.GiftCardsAppConstants.QUADRIGAM_STEPS.INICIO;
        }
        return step;
    };
}
GiftCardsDatalayerService.$inject = ['GiftCardsAppConstants', 'DatalayerConstants', 'DatalayerGeneralConstants', 'DatalayerUtilsService',
    'GiftCardsUtilService', 'localStorageService', '$rootScope', '$timeout'];
try {
    const mod = angular.module('ib-gift-cards-service-module');
    mod.service(
        'GiftCardsDatalayerService',
        GiftCardsDatalayerService
    );
} catch (error) {
    const mod = angular.module('ib-gift-cards-service-module', []);
    mod.service(
        'GiftCardsDatalayerService',
        GiftCardsDatalayerService
    );
}
